import { css } from '@/styled-system/css';

export const reviewSectionStyles = css.raw({
  marginBottom: '800',
});

export const reviewTitleRowStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '400',
});

export const iconPlaceholderStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  marginRight: '200',
  width: 'icon.md',
  flexShrink: 0,
});

export const reviewSectionTitleStyles = css.raw({
  display: 'flex',
  flexWrap: 'wrap',
  marginRight: '100',

  '& > *:not(:last-child)': {
    marginRight: '200 !important',
  },
});

export const componentStyles = css.raw({
  border: 'none',
  padding: 0,
});

export const propertyPhotoStyles = css.raw({
  borderRadius: '200',
  marginRight: {
    base: '200',
    md: '400',
  },
  minHeight: '2600',
  width: {
    base: '93px',
    md: '156px',
  },
  flexShrink: 0,
});

export const addressDetailsStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minWidth: 0,
});

export const verticalDividerStyles = css.raw({
  alignSelf: 'center',
  backgroundColor: 'border.neutral',
  display: 'inline-flex',
  height: '300',
  margin: { base: '0 {spacing.100}', md: '0 {spacing.200}' },
  width: '25',
});
